module.exports = __webpack_public_path__ + "static/media/earth.4aa86720.jpg";